<template>
    <div class="valuation-create-account__container">
        <div class="valuation-create-account__bg">
            <img src="/images/my-account/my-account-icon.svg" alt="" class="valuation-create-account__logo" />
        </div>
        <div class="valuation-create-account__form">
            <div v-if="showLogin === false">
                <div class="valuation-create-account__form-item">
                    <h3 class="valuation-create-account__heading">Would you like to create an account?</h3>
                    <p class="valuation-create-account__text">
                        In just a few clicks create your Stellantis &You UK account
                    </p>
                </div>
                <create-password :registration="valuation.reg_no" :mileage="valuation.mileage"/>
                <div class="valuation-create-account__form-item">
                    <p class="valuation-create-account__text">Already have an account <a href="#" @click.prevent="toggleLoginForm">log in</a></p>
                </div>
            </div>
            <div v-else-if="showResetPassword" class="valuation-create-account__grid-container">
                <div class="valuation-create-account__form-item">
                    <h1 class="valuation-create-account__heading">Reset Password</h1>
                </div>
                <ul v-if="hasErrors" class="validation-error__ul ul__no-bullet">
                    <li v-for="error in errors" :key="error" class="valuation-create-account__error validation-error__li validation-error--danger">{{ error }}</li>
                </ul>
                <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                    <li class="valuation-create-account__error validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <input v-model="form.email" type="text" data-validate="input"
                    data-validate-message="Please enter your email" name="email"
                    autocomplete="off" class="form-element__input" placeholder="Email address*">

                <a @click="resetPassword" class="btn btn--primary btn--full-width">SEND PASSWORD REST LINK</a>
                <a href="" @click.prevent="returnToLogin" class="valuation-create-account__link">Return to login</a>
            </div>
            <div v-else class="valuation-create-account__grid-container">
                <div class="valuation-create-account__form-item">
                    <h1 class="valuation-create-account__heading">Login to your account</h1>
                    <p class="valuation-create-account__text">
                        Save the valuation to your account to resume at a later date.
                    </p>
                </div>
                <ul v-if="hasErrors" class="validation-error__ul ul__no-bullet">
                    <li v-for="error in errors" :key="error" class="valuation-create-account__error validation-error__li validation-error--danger">{{ error }}</li>
                </ul>
                <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                    <li class="valuation-create-account__error validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <email :readonly="true" />
                <div class="valuation-create-account__password-container">
                    <input v-model="form.password"
                        class="form-element__input"
                        :type="passwordFieldType"
                        name="password"
                        id="password"
                        placeholder="Password*"
                        data-validate="password"
                        data-validate-message="Please enter a password">
                    <div class="valuation-create-account__toggle-password" @click="togglePasswordVisibility">
                        <img :src="eyeIcon" alt="Toggle Password" class="valuation-create-account__eye-icon" id="eye-icon">
                    </div>
                </div>
                <a type="button" @keypress.enter="login" @click="login" class="btn btn--primary btn--full-width">Sign In</a>
                <a href="" @click.prevent="toggleForgotPassword" class="valuation-create-account__link">Forgot Password?</a>
            </div>
            <div v-if="showLogin" class="valuation-create-account__form-item">
                <h2 class="valuation-create-account__form-h2">Don't have an account?</h2>
                <div class="valuation-create-account__form-item">
                    <button @click="register" class="btn btn--primary-inverted btn--full-width">CREATE AN ACCOUNT</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import CreatePassword from "../../../core/components/Forms/CreatePassword.vue";
import Email from "../../../core/components/Forms/Email.vue";

export default {

    components: {
      CreatePassword,
      Email
    },
    data() {
        return {
          form:{
                email:null,
                password:null,
            },
          showLogin:false,
          showResetPassword:false,
          showPassword: false
        };
    },
    props: {

    },

    computed: {
      ...mapState('ValuationTool', ['valuation', 'customerData']),
    //   ...mapGetters('CustomerData', ['customerData']),
      ...mapState("Auth", [
            'errors',
            'statusMessage'
        ]),

        hasErrors() {
            return this.errors && this.errors.length > 0;
        },

        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        },
        eyeIcon() {
            return this.showPassword ? '/images/my-account/eye-closed.svg' : '/images/my-account/eye-open.svg';
        }
    },

    mounted() {
    },
    methods: {
        ...mapMutations("Auth", ["setErrors", "setStatusMessage"]),
        ...mapActions("ValuationExtended", [ "storeValuation"]),
        ...mapActions("ValuationTool", [ "goToPosition"]),

        async login() {
            try{
                await this.$store.dispatch('Auth/login', { email: this.customerData.email, password: this.form.password })
                this.storeValuation();
                this.goToPosition('valuation-start')
            } catch (error) {
                console.error("Login failed:", error);
            }
        },
        resetPassword() {
            this.$store.dispatch('Auth/resetPassword', { email: this.form.email }).then(this.showResetPasswordd = false)
        },
        returnToLogin(){
            this.showLogin = true;
            this.showResetPassword = false;
            this.resetMessages();
        },
        resetMessages(){
            this.setStatusMessage();
            this.setErrors();
        },
        toggleLoginForm(){
            this.showLogin = true;
            this.resetMessages();
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleForgotPassword(){
            this.showResetPassword = true;
            this.resetMessages();
        },
        register() {
            this.showLogin = false;
            this.showResetPassword = false;
        }
    },
};
</script>
<style lang="scss">
  .validation-error{
    margin: 0 auto 10px;
    padding: 0;
    &__ul{
        list-style-image: none;
        margin: 0;
    }
  }
  .confirmation{
      &__create-account{
          &--passwords{
            display: grid;
            gap: 1rem;
          }
        }
      }
</style>
